import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Lock, PlayCircle, CircleCheck, ArrowDown } from '../../assets/icons';
import '../../assets/css/components/module_list.css';

const ModuleList = ({ modules, currentModule, currentSession, 
    completedModules, 
    completedSessions,
    onSessionSelect  }) => {
    const [expandedModule, setExpandedModule] = useState(currentModule);

    const toggleModule = (moduleIndex) => {
        setExpandedModule(expandedModule === moduleIndex ? null : moduleIndex);
    };

    return (
        <div className="module-list">
            <h2 className="module-list-title">Course Content</h2>
            {modules.map((module, moduleIndex) => (
                <div 
                    key={module.id} 
                    className={`module-item ${expandedModule === moduleIndex ? 'expanded' : ''}
                        ${completedModules.has(moduleIndex) ? 'completed' : ''}`}
                >
                    <div 
                        className="module-header"
                        onClick={() => toggleModule(moduleIndex)}
                    >
                        <div className="module-info">
                            <span className="module-number">Module {moduleIndex + 1}</span>
                            <h3>{module.title}</h3>
                        </div>
                        {completedModules.has(moduleIndex) && (
                            <img src={CircleCheck} alt="" className="status-icon completed" />
                        )}
                        <img src={ArrowDown} alt="" className="module-toggle-icon" />
                    </div>
                    
                    <ul className="session-list">
                        {module.sessions.map((session, sessionIndex) => {
                            const sessionKey = `${moduleIndex}-${sessionIndex}`;
                            const sessionNumber = parseInt(session.id.split('.')[1]);
                            const isUnlocked = moduleIndex < currentModule || 
                                (moduleIndex === currentModule && 
                                sessionNumber <= currentSession);
                            const isCompleted = moduleIndex < currentModule || 
                                (moduleIndex === currentModule && 
                                sessionNumber < currentSession) || completedSessions.has(sessionKey);
                            const isActive = moduleIndex === currentModule && 
                                sessionNumber === currentSession;
    

                            return (
                                <li 
                                    key={session.id}
                                    className={`session-item ${isUnlocked ? 'unlocked' : 'locked'}
                                        ${isCompleted ? 'completed' : ''} 
                                        ${isActive ? 'active' : ''}`}
                                    onClick={() => isUnlocked && onSessionSelect(moduleIndex, sessionIndex)}
                                >
                                    <div className="session-info">
                                        <div className="session-status">
                                            {isCompleted ? (
                                                <img src={CircleCheck} alt="" className="status-icon completed" />
                                            ) : isUnlocked ? (
                                                <img src={PlayCircle} alt="" className="status-icon" />
                                            ) : (
                                                <img src={Lock} alt="" className="status-icon locked" />
                                            )}
                                        </div>
                                        <span className="session-title">{session.title}</span>
                                    </div>
                                    <span className="session-duration">{session.duration}</span>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            ))}

        </div>
    );
};

ModuleList.propTypes = {
    modules: PropTypes.array.isRequired,
    currentModule: PropTypes.number.isRequired,
    currentSession: PropTypes.number.isRequired,
    completedModules: PropTypes.instanceOf(Set).isRequired,
    completedSessions: PropTypes.instanceOf(Set).isRequired,
    onSessionSelect: PropTypes.func.isRequired
};

export default ModuleList;